export const booking = {
    CREATE_BOOKING_SUCCESS: 'CREATE_BOOKING_SUCCESS',
    CREATE_BOOKING_FAILURE: 'CREATE_BOOKING_FAILURE',
    CREATE_BOOKING_LOADING: 'CREATE_BOOKING_LOADING',
    CLEAR_BOOKING: 'CLEAR_BOOKING',
}
  
